const { h, render, Component } = require('preact');
const FinePrint = require('./fine_print')
const RedemptionInstructions = require('./redemption_instructions')

class SSALinks extends Component {
  constructor(props) {
    super(props);
    this.getFinePrintInformation = this.getFinePrintInformation.bind(this)
  }

  showFinePrint() {
    if (lodash.has(this.props.orderDetails, 'metadata.serviceActions')) {
      return (this.props.orderDetails.metadata.serviceActions.indexOf('fine_print') > -1);
    }
    return false;
  }

  showRedemptionInstructions() {
    if (lodash.has(this.props.orderDetails, 'metadata.serviceActions')) {
      return (this.props.orderDetails.metadata.serviceActions.indexOf('redemption_instructions') > -1);
    }
    return false;
  }

  getFinePrintInformation() {
    if (this.props.orderDetails.finePrintText) {
      if (/<[a-z][\s\S]*>/i.test(this.props.orderDetails.finePrintText)) { // Checks if any HTML elements are present
        return <div
          class="ssa-information"
          dangerouslySetInnerHTML={{__html: this.props.orderDetails.finePrintText}}
        />
      }
      else {
        return (
          <div class="ssa-information">
            {this.props.orderDetails.finePrintText}
          </div>
        );
      }
    }
    else if (lodash.has(this.props.orderDetails, "groupons[0].extraAttributes.hotelFinePrint")) {
      return <div
        class="ssa-information"
        dangerouslySetInnerHTML={{__html: this.props.orderDetails.groupons[0].extraAttributes.hotelFinePrint}}
      />
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.showFinePrint() &&
        <FinePrint
          getFinePrintInformation={this.getFinePrintInformation()}
        />
        }
        {this.showRedemptionInstructions() &&
        <RedemptionInstructions orderDetails={this.props.orderDetails}/>
        }
      </div>
    );
  }
}

module.exports = SSALinks
